export var ContractType;
(function (ContractType) {
    ContractType["VENDITA"] = "VENDITA";
    ContractType["RINNOVO"] = "RINNOVO";
})(ContractType || (ContractType = {}));
export const contractTypes = Object.values(ContractType);
